<template>
  <div class="flex justify-center">
    <div class="max-w-screen-lg min-h-screen p-8">
      <h1 class="mb-8 text-heading">Vorverkaufsbedingungen</h1>
      <div class="text-body">
        <p>
          Mit dem Vorverkauf verpflichten Sie sich zur Abholung und Bezahlung
          der vorbestellten Karten an der Reservierungskasse bis spätestens 60
          Minuten vor Vorstellungsbeginn. Andernfalls verfällt der Anspruch auf
          die vorbestellten Karten. Der normale Eintritt kostet 9,- €, der
          ermäßigte Eintritt kostet 6,- €. An der Kasse ist nur Barzahlung
          möglich.
          <br />
          An den Sondervorstellungen und Abendveranstaltungen gelten
          Sonderkonditionen: Premiere, Arena Nostalgica, Circus Gala und Grande
          Finale kosten ermäßigt 8,-€ und normal 12,-€. Das Falschgeld Konzert
          („ Circus-Warm-Up featuring FALSCHGELD“) am 17.07.25 um 20 Uhr kostet
          ermäßigt 10,- € und regulär 15,-€. Hexagon Percussion am 23.07.25 um
          20:00 Uhr kostet ermäßigt 12,-€ und regulär 18,-€
          <br />
          Kinder unter drei Jahren haben freien Eintritt. Ermäßigt sind Kinder
          bis einschließlich 17 Jahre, sowie Schülerinnen und Schüler.
        </p>
      </div>
    </div>
  </div>
</template>
